import type { BookingFeeKind } from "./schemas/fees.ts";
import { DEFAULT_TIMEZONE, formatSessionTime } from "./time.ts";

/**
 * The words of a no-show or late-cancel fee (I2), in one place for the API (the payment request's
 * "what it is for", which the family reads on the pay page), Desk and the phone.
 */

/** "Missed session", "Late cancel". */
export function bookingFeeKindLabel(kind: BookingFeeKind): string {
  return kind === "no_show" ? "Missed session" : "Late cancel";
}

/** "Fee for a missed session: Reformer, Mon 26 Oct at 18:00". */
export function bookingFeeDescription(kind: BookingFeeKind, groupName: string, startsAt: Date, timeZone: string = DEFAULT_TIMEZONE): string {
  const what = kind === "no_show" ? "a missed session" : "a late cancel";
  return `Fee for ${what}: ${groupName}, ${formatSessionTime(startsAt, timeZone)}`;
}

/**
 * The message that goes with a payment link, for WhatsApp or the share sheet: Desk's payment link
 * box and the phone's Share link after Send. `amount` is already in the reader's money words.
 */
export function payLinkMessage(input: { businessName: string; amount: string; what: string; url: string }): string {
  return `${input.businessName ? `${input.businessName}: ` : ""}please pay ${input.amount} for ${input.what}. Pay by card here, you do not need an account: ${input.url}`;
}
